module.exports = __webpack_public_path__ + "static/media/3.2ea87654.jpg";